export enum WayfarersFlags {
    BackgroundAuthFormVersion = 'BACKGROUND_AUTH_FORM_VERSION',
    UseContractSearchV2 = 'use-contract-search-v2',
    SearchContractsAddHospitalSystemColumn = 'search-contracts-add-hospital-system-column',
    UnlinkBackButtonFromBrowserAction = 'unlink-back-button-from-browser-action',
    EnableLocums1099MarginCalculator = 'enable-locums-1099-margin-calculator'
}
